import { AppBar } from "react-admin";
import { Box, useMediaQuery, Theme } from "@mui/material";

import { AppBarToolbar } from "./AppBarToolbar";
import publishArticleImage from "/welcome_illustration.svg";

const CustomAppBar = () => {
  const isLargeEnough = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.up("sm")
  );
  return (
    <AppBar color="secondary" toolbar={<AppBarToolbar />}>
      {isLargeEnough && (
        <Box
          display={{ xs: "none", sm: "none", md: "block" }}
          sx={{
            background: `url(${publishArticleImage}) top right / cover`,
            marginLeft: "auto",
          }}
          width="8.5em"
          height="1em"
          overflow="hidden"
        />
      )}

      {isLargeEnough && <Box component="span" sx={{ flex: 1 }} />}
    </AppBar>
  );
};

export default CustomAppBar;
